module.exports = __webpack_public_path__ + "img/uca.0db42e37.webp";